export default "__VITE_ASSET__DgWkbVoG__"